module.exports = __webpack_public_path__ + "static/img/xy_41000028.d382414a.png";